export const navbar = {
  brand: 'Contracte',
  userMenu: {
    myProfile: 'Profilul meu',
    notificationSubscriptionsAdmin: 'Abonamente notificări',
    signOut: 'Deconectare'
  }
}
